<template>
  <router-view />
</template>

<script>
export default {
  name: "availability",
};
</script>
